import { IconButton, InputAdornment, TextField } from "@mui/material";
import type { FC, ReactNode } from "react";
import { useMemo } from "react";
import type { TextFieldProps } from "@mui/material/TextField";
import ClearIcon from "@mui/icons-material/Clear";

interface Props {
  readonly readonly?: boolean;
  readonly clearable?: boolean;
  readonly onChange: (value: string) => void;
}

const DatePicker: FC<Props & Omit<TextFieldProps, "onChange">> = ({
  readonly,
  clearable,
  onChange,
  value,
  ...rest
}) => {
  const endAdornment: ReactNode =
    value && clearable && !readonly ? (
      <InputAdornment position="end">
        <IconButton aria-label="clear date" onClick={() => onChange("")} edge="end">
          <ClearIcon />
        </IconButton>
      </InputAdornment>
    ) : null;
  const slotProps = useMemo(
    () => ({
      inputLabel: { shrink: true },
      htmlInput: { "aria-label": rest.label, role: "datePicker" },
      input: {
        readOnly: readonly,
        endAdornment,
      },
    }),
    [rest.label, readonly, endAdornment],
  );
  return (
    <TextField
      type="date"
      value={value ?? ""}
      slotProps={slotProps}
      onChange={(e) => onChange(e.target.value)}
      {...rest}
    />
  );
};

export default DatePicker;
